import { type Report, type Result } from "../../reporter";
import { type ValidateStringFn, createSyncFn, jestWorkerPath } from "../worker";

/**
 * @internal
 */
export function getResults(filename: string, value: Report | string): Result[] {
	if (typeof value === "string") {
		const syncFn = createSyncFn<ValidateStringFn>(jestWorkerPath);
		const report = syncFn(value, filename, {
			rules: {
				"void-style": "off",
			},
		});
		return report.results.map((it) => {
			return { ...it, filePath: "inline" };
		});
	}
	return value.results;
}
